module.exports = __webpack_public_path__ + "img/Tagaytay.7cc99fb0.png";